import { addProfileWidget } from './addProfileWidget';
import { deleteProfileWidget } from './deleteProfileWidget';

export const widgets = {
  addProfileWidget,
  deleteProfileWidget,
};
